import React, { useState } from "react";
import { LiaUsersCogSolid } from "react-icons/lia";
import { MdGroups2 } from "react-icons/md";
import { FaUsersBetweenLines } from "react-icons/fa6";
import CustomersGroups from "../../components/Customers/groups/CustomersGroups";
import CustomersHome from "../../components/Customers/CustomersHome";
import { useTranslation } from "react-i18next";
import { CardHeadeWithActions } from "../../components/ui";

const Customers = () => {
  const [tabActive, setTabActive] = useState("customers");
  const [t] = useTranslation("global");

  return (
    <>
      <CardHeadeWithActions>
        <div className="w-[100%] mb-0 flex justify-between items-center">
          <div className="title flex justify-center gap-1 items-center">
            <LiaUsersCogSolid size={18} />
            <span className="text-[#261759] ms-1 font-bold ">
              {t("customers.title")}
            </span>
          </div>
        </div>
      </CardHeadeWithActions>
      <div id="Tabs" className="w-full flex mt-3 gap-2 bg-[#F8FAFC] rounded-md p-1">
        <div
          onClick={() => setTabActive("customers")}
          className={`flex-1 flex flex-col gap-1 items-center justify-center rounded-md text-[#261759] p-3 cursor-pointer transition ${
            tabActive === "customers"
              ? "bg-[#EBF9D9] font-bold"
              : "bg-white"
          }`}
        >
          <FaUsersBetweenLines size={28} />
          <hr />
          <span className="text-sm ">{t("customers.customers")}</span>
        </div>
        <div
          onClick={() => setTabActive("Groups")}
          className={`flex-1 flex flex-col gap-1 items-center justify-center rounded-md text-[#261759] p-3 cursor-pointer transition ${
            tabActive === "Groups"
              ? "bg-[#EBF9D9] font-bold"
              : "bg-white"
          }`}
        >
          <MdGroups2 size={28} />
          <hr />
          <span className="text-sm  ">{t("customers.customerGroups")}</span>
        </div>
      </div>
      <div className="text-[#261759] bg-[#F8FAFC] rounded-md text-xs p-3 py-5 mt-2">
        {tabActive === "customers" && <CustomersHome />}
        {tabActive === "Groups" && <CustomersGroups />}
      </div>
    </>
  );
};

export default Customers;
